import { Button, List, Skeleton, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { LockOutlined, MailOutlined, MessageOutlined } from "@ant-design/icons";

type CardProps = {
  list?: any[];
  loading?: boolean;
  choose?: any;
};

const icons: any = {
  authenticator: <LockOutlined className="text-primary" />,
  email: <MailOutlined  className="text-primary"/>,
  sms: <MessageOutlined  className="text-primary"/>,
};
export const MfaTypeList: React.FC<CardProps> = ({ list, loading, choose }) => {
  const { t } = useTranslation("login");

  return (
    <div
      style={{
        height: 400,
        overflow: "auto",
        padding: "16px 0px",
      }}
    >
      <List
        loading={loading}
        dataSource={list}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                onClick={() => choose(item)}
                type="text"
                key="list-loadmore-edit"
              >
                {t("choose")}
              </Button>,
            ]}
          >
            <Skeleton avatar title={false} loading={loading} active>
              <List.Item.Meta
                avatar={icons[item]}
                description={<h3 className="text-dark truncate capitalize">
                  {item}
                </h3>}
              />
            </Skeleton>
          </List.Item>
        )}
      />
    </div>
  );
};
